import * as help from '@appStore/help/actions/help.actions';
import * as guides from '@appStore/help/actions/guides.actions';
import * as userGuides from '@appStore/help/actions/user-guides.actions';

export * from '@appStore/help/actions/help.actions';
export * from '@appStore/help/actions/guides.actions';
export * from '@appStore/help/actions/user-guides.actions';

export const ActionTypes = {
  ...help.HelpActionTypes,
  ...guides.GuidesActionTypes,
  ...userGuides.UserGuidesActionTypes
};

export type Actions = help.HelpActions | guides.GuidesActions | userGuides.UserGuidesActions;
